import { Component } from '@angular/core';

@Component({
    selector: 'gl-edit-subscriptions-page',
    templateUrl: './edit-subscriptions-page.component.html',
    styleUrls: ['./edit-subscriptions-page.component.scss']
})
export class EditSubscriptionsPageComponent {}
